export const STATUS_TYPE = {
  0: { text: '未发布', color: 'info' },
  1: { text: '已发布', color: 'success' }
};

export const PAGINATION = {
  page: 1,
  size: 25
};
